import Toastr from "../../../itrust_common/components/Toastr"
const parent = 'STORE_SETTING'

const DEFAULT_STATE = {
  available_numbers: [],
  store_setting: {},
  store_settings: [],
  filtered_store_settings: [],
  saving: false,
  loading: false,
}
let changes = null;

const getFilteredData = (arr) => {
  let valArr = arr?.reduce(
    (acc, item) => {
      if (!acc[item.category]) acc[item.category] = []
      acc[item.category].push(item)
      return acc
    },
    {
      lab_order_material_status: [], // multiple
      prescription_expiration: [], // single
      payment_method: [], // single
      abb_customer: [], // single
      card_types: [], // multiple
      tax_settings: [], // single
    }
  )
  valArr = {
    ...valArr,
    lab_order_material_status: valArr.lab_order_material_status?.filter(item => item.is_archived == false) || [] // filter ac
  }
  return valArr;
}

export default function storeSettingReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let store_settings = [];
  let storeSettingData = [];
  let updatedRecord = {};

  switch (action.type) {
    case `${parent}_UPDATE_PENDING`:
    case `${parent}_CREATE_PENDING`:
    case 'FAIT_SETTING_CREATE_PENDING':
      return { ...state, saving: true };

    case `${parent}_LOAD_PENDING`:
    case `${parent}_DEVICES_LOAD_PENDING`:
    case `${parent}_DEVICE_UPDATE_PENDING`:
      return { ...state, loading: true };

    case `${parent}_UPDATE_REJECTED`:
    case `${parent}_DEVICES_LOAD_REJECTED`:
    case `${parent}_DEVICE_LOAD_REJECTED`:
    case `${parent}_DEVICE_UPDATE_REJECTED`:
    case `${parent}_CREATE_REJECTED`:
    case `${parent}_DELETE_REJECTED`:
    case 'FAIT_SETTING_CREATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false,
      }
      return { ...state, ...changes };

    case `${parent}_LOAD_FULFILLED`:
      changes = {
        ...response,
        saving: false,
        loading: false,
        filtered_store_settings: getFilteredData(response.store_settings),
      };
      return { ...state, ...changes };

    case `${parent}_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      store_settings = [...state.store_settings, response.store_setting]
      changes = {
        ...response,
        saving: false,
        store_settings: store_settings,
        filtered_store_settings: getFilteredData(store_settings),
      };
      return { ...state, ...changes };

    case `${parent}_UPDATE_FULFILLED`:
    case 'VISION_WEB_SETTING_CREATE_FULFILLED':
    case 'FAIT_SETTING_CREATE_FULFILLED':
      if (action.type === `${parent}_UPDATE_FULFILLED` || action.type === 'FAIT_SETTING_CREATE_FULFILLED') {
        Toastr.handleShow(true, response.meta.message, 201)
      }
      store_settings = [...state.store_settings]
      updatedRecord = response.store_setting
      storeSettingData = store_settings
      for (const [index, order] of store_settings.entries()) {
        if (order.id === updatedRecord.id) {
          storeSettingData = [
            ...store_settings.slice(0, index),
            updatedRecord,
            ...store_settings.slice(index + 1)
          ];
        }
      }
      changes = {
        saving: false,
        store_settings: storeSettingData,
        filtered_store_settings: getFilteredData(storeSettingData)
      };
      return { ...state, ...changes };

    case `${parent}_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      store_settings = [...state.store_settings]
      for (const [index, store_setting] of store_settings.entries()) {
        if (store_setting.id === response.store_setting.id) {
          store_settings.splice(index, 1);
        }
      }
      changes = {
        ...state,
        saving: false,
        store_settings: store_settings,
        filtered_store_settings: getFilteredData(store_settings)
      };
      return { ...state, ...changes };

    case `${parent}_DEVICES_LOAD_FULFILLED`:
      changes = {
        store_setting: { device_integrations: response.device_integrations },
        saving: false,
        loading: false,
      };
      return { ...state, ...changes };

    case `${parent}_DEVICE_LOAD_FULFILLED`:
      changes = {
        store_setting: { ...state.store_setting, device_integration: response.device_integration },
        saving: false,
        loading: false,
      };
      return { ...state, ...changes };

    case `${parent}_DEVICE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        store_setting: { ...state.store_setting, device_integration: response.device_integration },
        saving: false,
        loading: false,
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}
